import { render, staticRenderFns } from "./Deviations.vue?vue&type=template&id=05737617&"
import script from "./Deviations.vue?vue&type=script&lang=js&"
export * from "./Deviations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports